import React from 'react';
import { useModal } from 'components/v2/Modal/useModal';
import { refreshReportItem } from '../../reports/hooks/use-report-item';
import {
  DirectoryIntelligenceFieldsForm,
  Props,
} from '../forms/IntelligenceFieldsForm';
import { Dir } from '../../dirs';
import useSnackbars from '../../../components/v2/Snackbar/use-snackbars';
import { useTranslation } from 'utils/translation';
import { createModalFormFooter } from '../../../components/v2/Modal/createModalFormFooter';

type Options = Pick<Props, 'onSuccess'> & {
  enableTitle?: boolean;
  groups?: string[];
};

const DIRECTORY_INTELLIGENCE_FORM_ID =
  'intelligence-layer-directory-fields-form';

const DirectoryIntelligenceModalFooter = createModalFormFooter(
  DIRECTORY_INTELLIGENCE_FORM_ID,
);

export default function useDirectoryIntelligenceFieldsForm(
  id: Dir['id'],
  { onSuccess, enableTitle = false, groups }: Options = {},
) {
  const modal = useModal();
  const snackbars = useSnackbars();
  const { t } = useTranslation();

  return () =>
    modal.open(
      ({ close }) => (
        <DirectoryIntelligenceFieldsForm
          formId={DIRECTORY_INTELLIGENCE_FORM_ID}
          id={id}
          enableTitle={enableTitle}
          groups={groups}
          onSuccess={() => {
            close();
            onSuccess?.();
            refreshReportItem(id);
            snackbars.add({
              variant: 'success',
              message: t('Successfully updated'),
            });
          }}
        />
      ),
      {
        title: t('intelligence_layer_modal_directory_title'),
        footer: DirectoryIntelligenceModalFooter,
      },
    );
}
